module.exports = __webpack_public_path__ + "static/media/Marotte_Noyer_Sepium_MT12-22-Scale.5842b365.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Noyer_Sepium_MT12-22-Scale.jpg
// module id = 960
// module chunks = 37